import styled from 'styled-components';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const LightText = styled.span`
  color: ${colors.textSecondary};
  margin-left: 0;
`;

export const AbsolutePositionWrapper = styled.div`
  background-color: ${colors.white};
  position: absolute;
  right: 0;
  top: ${pxToRem(42)};
  z-index: 10000;
`;
